import { render } from "./MobileFiltersModal.vue?vue&type=template&id=8520a528&ts=true"
import script from "./MobileFiltersModal.vue?vue&type=script&lang=ts"
export * from "./MobileFiltersModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__